import {
  RESET_COMPANY,
  API_ERROR,
  GET_COMPANY,
  SET_COMPANY,
  EDIT_COMPANY,
  EDIT_COMPANY_SUCCESS,
} from "./actionTypes";

export const resetCompany = () => {
  return {
    type: RESET_COMPANY,
    payload: {},
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const getCompany = () => {
  return {
    type: GET_COMPANY,
    payload: {},
  };
};
export const setCompany = (data) => {
  return {
    type: SET_COMPANY,
    payload: { data },
  };
};

export const editCompany = (newCompanyValues) => {
  return {
    type: EDIT_COMPANY,
    payload: { newCompanyValues },
  };
};
export const editCompanySuccess = (newCompanyValues, message) => {
  return {
    type: EDIT_COMPANY_SUCCESS,
    payload: { newCompanyValues, message },
  };
};
